// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   Box,
//   Grid,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   TextField,
//   InputAdornment,
//   IconButton,
//   Tooltip,
// } from "@mui/material";
// import {
//   Inventory2,
//   LocalShipping,
//   SyncAlt,
//   CheckCircle,
//   Refresh,
//   Search,
//   Warehouse,
// } from "@mui/icons-material";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip as ChartTooltip,
//   Legend,
// } from "chart.js";
// import axiosClient from "../../configs/axios";
// import depotMasterService from "../../services/masters/depotMaster.Service";
// import deliveryChallanService from "../../services/deliveryChallan.Service";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, ChartTooltip, Legend);

// // ── Design tokens ──────────────────────────────────────────────────────────────
// const C = {
//   bg:          "#F4F7FB",
//   card:        "#FFFFFF",
//   border:      "#E2E8F0",
//   navy:        "#1B3A6B",
//   navyLight:   "#EFF4FC",
//   accent:      "#2563EB",
//   full:        "#16A34A",
//   fullBg:      "#DCFCE7",
//   empty:       "#DC2626",
//   emptyBg:     "#FEE2E2",
//   transit:     "#D97706",
//   transitBg:   "#FEF3C7",
//   delivered:   "#2563EB",
//   deliveredBg: "#EFF6FF",
//   muted:       "#64748B",
//   radius:      "10px",
// };

// // ── Helpers ────────────────────────────────────────────────────────────────────
// const getUserInfo = () => {
//   try {
//     const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
//     return d?.result?.userInfo || {};
//   } catch {
//     return {};
//   }
// };

// const toDateStr = (v) => {
//   if (!v) return "-";
//   const s = String(v);
//   return s.includes("T") ? s.split("T")[0] : s.split(" ")[0];
// };

// const todayISO = () => new Date().toISOString().split("T")[0];

// // Count cylinders in table_details JSON array
// const countCylinders = (tableDetails) => {
//   try {
//     const arr = typeof tableDetails === "string" ? JSON.parse(tableDetails) : tableDetails;
//     if (!Array.isArray(arr)) return 0;
//     return arr.filter((c) => c.cyl_id).length;
//   } catch {
//     return 0;
//   }
// };

// const statusMap = {
//   delivered:   { label: "Delivered",   color: "success" },
//   "in-transit":{ label: "In Transit",  color: "warning" },
//   cancelled:   { label: "Cancelled",   color: "error"   },
//   booked:      { label: "Booked",      color: "info"    },
//   created:     { label: "Created",     color: "default" },
// };

// // ── Sub-components ─────────────────────────────────────────────────────────────

// const KpiCard = ({ icon: Icon, label, value, accentColor, bgColor, loading }) => (
//   <Box
//     sx={{
//       background: C.card,
//       border: `1px solid ${C.border}`,
//       borderLeft: `4px solid ${accentColor}`,
//       borderRadius: C.radius,
//       p: "16px 18px",
//       display: "flex",
//       alignItems: "center",
//       gap: 2,
//       height: "100%",
//     }}
//   >
//     <Box
//       sx={{
//         width: 46,
//         height: 46,
//         borderRadius: "10px",
//         background: bgColor,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         flexShrink: 0,
//       }}
//     >
//       <Icon sx={{ fontSize: 22, color: accentColor }} />
//     </Box>
//     <Box>
//       {loading ? (
//         <CircularProgress size={20} sx={{ color: accentColor }} />
//       ) : (
//         <Box sx={{ fontSize: 28, fontWeight: 700, color: C.navy, lineHeight: 1 }}>
//           {value ?? "—"}
//         </Box>
//       )}
//       <Box sx={{ fontSize: 12, color: C.muted, mt: "4px", fontWeight: 500 }}>{label}</Box>
//     </Box>
//   </Box>
// );

// const SectionLabel = ({ children }) => (
//   <Box
//     sx={{
//       fontSize: 11,
//       fontWeight: 600,
//       color: C.muted,
//       letterSpacing: "1px",
//       textTransform: "uppercase",
//       mb: 1.5,
//       mt: 0.5,
//     }}
//   >
//     {children}
//   </Box>
// );

// const CardWrap = ({ title, badge, loading, children }) => (
//   <Box
//     sx={{
//       background: C.card,
//       border: `1px solid ${C.border}`,
//       borderRadius: C.radius,
//       p: "18px 20px",
//       height: "100%",
//     }}
//   >
//     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//       <Box sx={{ fontSize: 14, fontWeight: 600, color: C.navy }}>{title}</Box>
//       {badge && (
//         <Chip label={badge} size="small" sx={{ fontSize: 11, background: C.navyLight, color: C.accent, fontWeight: 600 }} />
//       )}
//     </Box>
//     {loading ? (
//       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
//         <CircularProgress size={24} sx={{ color: C.accent }} />
//       </Box>
//     ) : (
//       children
//     )}
//   </Box>
// );

// const BASE_CHART_OPTS = {
//   responsive: true,
//   maintainAspectRatio: false,
//   scales: {
//     y: {
//       beginAtZero: true,
//       grid: { color: "rgba(0,0,0,0.04)" },
//       ticks: { font: { size: 11 }, color: C.muted },
//     },
//     x: {
//       grid: { display: false },
//       ticks: { font: { size: 11 }, color: C.muted, autoSkip: false, maxRotation: 0 },
//     },
//   },
//   plugins: {
//     legend: { display: false },
//     tooltip: { mode: "index", intersect: false },
//   },
// };

// // ── Main Component ─────────────────────────────────────────────────────────────
// const DepotDashboard = () => {
//   const userInfo = useMemo(() => getUserInfo(), []);
//   // Depot user ka own depot_id, or admin ke liye dropdown se select
//   const defaultDepotId = userInfo?.depot_id ? String(userInfo.depot_id) : "";

//   // Masters
//   const [depots, setDepots] = useState([]);

//   // Filters
//   const [selectedDepot, setSelectedDepot] = useState(defaultDepotId);

//   // Inventory stats (from /dashboard/inventory)
//   const [invData, setInvData] = useState(null);
//   const [invLoading, setInvLoading] = useState(false);

//   // Depot-wise cylinder count (from /dashboard/depot-cylinder-count)
//   const [depotCount, setDepotCount] = useState([]);
//   const [depotCountLoading, setDepotCountLoading] = useState(false);

//   // Delivery challans (from /delivery-challan/list)
//   const [challans, setChallans] = useState([]);
//   const [challanLoading, setChallanLoading] = useState(false);
//   const [challanSearch, setChallanSearch] = useState("");
//   const [challanPage] = useState(0);
//   const [challanSize] = useState(50);

//   // Today date for display
//   const today = useMemo(() => todayISO(), []);

//   // ── Fetch masters ──
//   useEffect(() => {
//     depotMasterService
//       .getDepotList({ page: 0, size: 999, searchKey: "" })
//       .then((data) => setDepots(data || []))
//       .catch(console.error);
//   }, []);

//   // ── Fetch inventory stats ──
//   const fetchInventory = useCallback(() => {
//     setInvLoading(true);
//     const params = {};
//     if (selectedDepot) params.depot_id = selectedDepot;
//     axiosClient
//       .get("/dashboard/inventory", { params })
//       .then((r) => setInvData(r.data || {}))
//       .catch(() => setInvData(null))
//       .finally(() => setInvLoading(false));
//   }, [selectedDepot]);

//   // ── Fetch depot-wise cylinder count ──
//   const fetchDepotCount = useCallback(() => {
//     setDepotCountLoading(true);
//     axiosClient
//       .get("/dashboard/depot-cylinder-count")
//       .then((r) => setDepotCount(r.data || []))
//       .catch(() => setDepotCount([]))
//       .finally(() => setDepotCountLoading(false));
//   }, []);

//   // ── Fetch delivery challans ──
//   const fetchChallans = useCallback(() => {
//     setChallanLoading(true);
//     deliveryChallanService
//       .getDeliveryChallanList({
//         page: challanPage,
//         size: challanSize,
//         searchKey: challanSearch,
//         depot_id: selectedDepot || "",
//       })
//       .then((data) => {
//         const rows = Array.isArray(data) ? data : data?.data || [];
//         setChallans(rows);
//       })
//       .catch(() => setChallans([]))
//       .finally(() => setChallanLoading(false));
//   }, [selectedDepot, challanPage, challanSize, challanSearch]);

//   useEffect(() => { fetchInventory(); }, [fetchInventory]);
//   useEffect(() => { fetchDepotCount(); }, [fetchDepotCount]);
//   useEffect(() => { fetchChallans(); }, [fetchChallans]);

//   // ── KPI values ──
//   const fullCount     = invData ? (invData.full?.tgpl || 0) + (invData.full?.customer || 0) : null;
//   const emptyCount    = invData ? (invData.empty?.tgpl || 0) + (invData.empty?.customer || 0) : null;
//   const inTransit     = invData ? invData.inTransit || 0 : null;

//   // Delivered today — count challans with today's entry_date
//   const deliveredToday = useMemo(() => {
//     if (!challans.length) return 0;
//     return challans
//       .filter((c) => toDateStr(c.entry_date) === today && !c.is_deleted)
//       .reduce((sum, c) => sum + countCylinders(c.table_details), 0);
//   }, [challans, today]);

//   // ── Bar chart: depot-wise full vs empty ──
//   const barData = useMemo(() => {
//     const rows = selectedDepot
//       ? depotCount.filter((r) => String(r.depot_id) === String(selectedDepot))
//       : depotCount;
//     if (!rows.length) return null;
//     return {
//       labels: rows.map((r) => r.depot_name || `Depot ${r.depot_id}`),
//       datasets: [
//         {
//           label: "Full",
//           data: rows.map((r) => Number(r.full_count) || 0),
//           backgroundColor: C.full,
//           borderRadius: 4,
//           barPercentage: 0.55,
//         },
//         {
//           label: "Empty",
//           data: rows.map((r) => Number(r.empty_count) || 0),
//           backgroundColor: C.empty,
//           borderRadius: 4,
//           barPercentage: 0.55,
//         },
//       ],
//     };
//   }, [depotCount, selectedDepot]);

//   // ── Filtered challans ──
//   const filteredChallans = useMemo(() => {
//     if (!challanSearch) return challans;
//     const q = challanSearch.toLowerCase();
//     return challans.filter(
//       (c) =>
//         c.entry_no?.toLowerCase().includes(q) ||
//         c.to_customer_id?.toLowerCase?.().includes(q) ||
//         c.driver_name?.toLowerCase?.().includes(q) ||
//         c.vehicle_no?.toLowerCase?.().includes(q)
//     );
//   }, [challans, challanSearch]);

//   // ── Refresh all ──
//   const refreshAll = () => {
//     fetchInventory();
//     fetchDepotCount();
//     fetchChallans();
//   };

//   // ── Status chip ──
//   const StatusChip = ({ status }) => {
//     const key = (status || "").toLowerCase().replace(/\s+/g, "-");
//     const cfg = statusMap[key] || { label: status || "—", color: "default" };
//     return <Chip label={cfg.label} color={cfg.color} size="small" sx={{ fontSize: 11, fontWeight: 600 }} />;
//   };

//   // ── Render ──────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ background: C.bg, minHeight: "100vh", p: "20px 22px 32px", fontFamily: "'Inter', Arial, sans-serif" }}>

//       {/* ── Header ── */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           mb: 3,
//           flexWrap: "wrap",
//           gap: 2,
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//           <Box
//             sx={{
//               width: 40,
//               height: 40,
//               borderRadius: "10px",
//               background: C.navy,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <Warehouse sx={{ color: "#fff", fontSize: 22 }} />
//           </Box>
//           <Box>
//             <Box sx={{ fontSize: 18, fontWeight: 700, color: C.navy, lineHeight: 1.2 }}>
//               Depot Dashboard
//             </Box>
//             <Box sx={{ fontSize: 11, color: C.muted, mt: "2px" }}>
//               {today} · Cylinder Inventory & Delivery
//             </Box>
//           </Box>
//         </Box>

//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
//           {/* Depot filter (only for non-depot users) */}
//           {!defaultDepotId && (
//             <FormControl size="small" sx={{ minWidth: 160 }}>
//               <InputLabel sx={{ fontSize: 12 }}>Select Depot</InputLabel>
//               <Select
//                 value={selectedDepot}
//                 label="Select Depot"
//                 onChange={(e) => setSelectedDepot(e.target.value)}
//                 sx={{ fontSize: 12, borderRadius: "8px", "& fieldset": { borderColor: C.border } }}
//               >
//                 <MenuItem value=""><em>All Depots</em></MenuItem>
//                 {depots.map((d) => (
//                   <MenuItem key={d.depot_id} value={String(d.depot_id)} sx={{ fontSize: 12 }}>
//                     {d.depot_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}

//           <Tooltip title="Refresh all">
//             <IconButton
//               onClick={refreshAll}
//               size="small"
//               sx={{ border: `1px solid ${C.border}`, borderRadius: "8px", p: "6px", background: C.card }}
//             >
//               <Refresh fontSize="small" sx={{ color: C.navy }} />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       </Box>

//       {/* ── KPI Strip ── */}
//       <SectionLabel>Inventory Overview</SectionLabel>
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <KpiCard
//             icon={Inventory2}
//             label="Full Cylinders"
//             value={fullCount !== null ? fullCount.toLocaleString() : null}
//             accentColor={C.full}
//             bgColor={C.fullBg}
//             loading={invLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <KpiCard
//             icon={Inventory2}
//             label="Empty Cylinders"
//             value={emptyCount !== null ? emptyCount.toLocaleString() : null}
//             accentColor={C.empty}
//             bgColor={C.emptyBg}
//             loading={invLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <KpiCard
//             icon={SyncAlt}
//             label="In Transit"
//             value={inTransit !== null ? inTransit.toLocaleString() : null}
//             accentColor={C.transit}
//             bgColor={C.transitBg}
//             loading={invLoading}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <KpiCard
//             icon={CheckCircle}
//             label="Delivered Today"
//             value={deliveredToday.toLocaleString()}
//             accentColor={C.delivered}
//             bgColor={C.deliveredBg}
//             loading={challanLoading}
//           />
//         </Grid>
//       </Grid>

//       {/* ── Charts Row ── */}
//       <SectionLabel>Depot-wise Cylinder Breakdown</SectionLabel>
//       <Grid container spacing={2} sx={{ mb: 3 }}>

//         {/* Bar Chart: Full vs Empty per depot */}
//         <Grid item xs={12} lg={8}>
//           <CardWrap title="Full vs Empty — Depot Wise" badge="Live" loading={depotCountLoading}>
//             {/* Legend */}
//             <Box sx={{ display: "flex", gap: 2, mb: 1.5 }}>
//               {[
//                 { label: "Full",  color: C.full  },
//                 { label: "Empty", color: C.empty },
//               ].map((l) => (
//                 <Box key={l.label} sx={{ display: "flex", alignItems: "center", gap: "5px", fontSize: 11, color: C.muted }}>
//                   <Box sx={{ width: 10, height: 10, borderRadius: 2, background: l.color }} />
//                   {l.label}
//                 </Box>
//               ))}
//             </Box>
//             {barData ? (
//               <Box sx={{ height: 240, position: "relative" }}>
//                 <Bar
//                   data={barData}
//                   options={{
//                     ...BASE_CHART_OPTS,
//                     plugins: {
//                       ...BASE_CHART_OPTS.plugins,
//                       tooltip: {
//                         mode: "index",
//                         intersect: false,
//                         callbacks: {
//                           label: (ctx) => ` ${ctx.dataset.label}: ${ctx.parsed.y}`,
//                         },
//                       },
//                     },
//                   }}
//                 />
//               </Box>
//             ) : (
//               <Box sx={{ fontSize: 13, color: C.muted, py: 4, textAlign: "center" }}>
//                 No depot data available.
//               </Box>
//             )}
//           </CardWrap>
//         </Grid>

//         {/* Summary Panel */}
//         <Grid item xs={12} lg={4}>
//           <CardWrap title="Inventory Summary" loading={depotCountLoading}>
//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//               {(selectedDepot
//                 ? depotCount.filter((r) => String(r.depot_id) === String(selectedDepot))
//                 : depotCount
//               ).map((row) => {
//                 const total = Number(row.total_count) || 0;
//                 const full  = Number(row.full_count)  || 0;
//                 const empty = Number(row.empty_count) || 0;
//                 const fullPct  = total ? Math.round((full  / total) * 100) : 0;
//                 const emptyPct = total ? Math.round((empty / total) * 100) : 0;
//                 return (
//                   <Box key={row.depot_id}>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", mb: "4px" }}>
//                       <Box sx={{ fontSize: 12, fontWeight: 600, color: C.navy }}>
//                         {row.depot_name || `Depot ${row.depot_id}`}
//                       </Box>
//                       <Box sx={{ fontSize: 11, color: C.muted }}>{total} total</Box>
//                     </Box>
//                     {/* Full bar */}
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: "3px" }}>
//                       <Box sx={{ fontSize: 10, color: C.full, width: 32 }}>Full</Box>
//                       <Box sx={{ flex: 1, height: 6, background: "#E2E8F0", borderRadius: 3, overflow: "hidden" }}>
//                         <Box sx={{ width: `${fullPct}%`, height: "100%", background: C.full, borderRadius: 3, transition: "width 0.5s" }} />
//                       </Box>
//                       <Box sx={{ fontSize: 10, color: C.full, minWidth: 28, textAlign: "right" }}>{full}</Box>
//                     </Box>
//                     {/* Empty bar */}
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                       <Box sx={{ fontSize: 10, color: C.empty, width: 32 }}>Empty</Box>
//                       <Box sx={{ flex: 1, height: 6, background: "#E2E8F0", borderRadius: 3, overflow: "hidden" }}>
//                         <Box sx={{ width: `${emptyPct}%`, height: "100%", background: C.empty, borderRadius: 3, transition: "width 0.5s" }} />
//                       </Box>
//                       <Box sx={{ fontSize: 10, color: C.empty, minWidth: 28, textAlign: "right" }}>{empty}</Box>
//                     </Box>
//                   </Box>
//                 );
//               })}
//               {depotCount.length === 0 && (
//                 <Box sx={{ fontSize: 13, color: C.muted, textAlign: "center", py: 3 }}>No data.</Box>
//               )}
//             </Box>
//           </CardWrap>
//         </Grid>
//       </Grid>

//       {/* ── Delivery Challan Table ── */}
//       <SectionLabel>Delivery Challans</SectionLabel>
//       <Box sx={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: C.radius, overflow: "hidden" }}>

//         {/* Table header row */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             p: "14px 18px",
//             borderBottom: `1px solid ${C.border}`,
//             flexWrap: "wrap",
//             gap: 1.5,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             <LocalShipping sx={{ fontSize: 18, color: C.accent }} />
//             <Box sx={{ fontSize: 14, fontWeight: 600, color: C.navy }}>Delivery Challan</Box>
//             <Chip
//               label={`${filteredChallans.length} records`}
//               size="small"
//               sx={{ fontSize: 11, background: C.navyLight, color: C.accent }}
//             />
//           </Box>
//           <TextField
//             size="small"
//             placeholder="Search challan no., customer, driver…"
//             value={challanSearch}
//             onChange={(e) => setChallanSearch(e.target.value)}
//             sx={{
//               width: 280,
//               "& .MuiOutlinedInput-root": {
//                 fontSize: 12,
//                 borderRadius: "8px",
//                 "& fieldset": { borderColor: C.border },
//               },
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Search sx={{ fontSize: 16, color: C.muted }} />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Box>

//         <TableContainer sx={{ maxHeight: 480 }}>
//           <Table size="small" stickyHeader>
//             <TableHead>
//               <TableRow>
//                 {[
//                   "Challan No.",
//                   "Entry Date",
//                   "Customer",
//                   "Driver",
//                   "Vehicle",
//                   "Cylinders",
//                   "Qty (KG)",
//                   "Status",
//                 ].map((h) => (
//                   <TableCell
//                     key={h}
//                     sx={{
//                       fontSize: 11,
//                       fontWeight: 600,
//                       color: C.muted,
//                       textTransform: "uppercase",
//                       letterSpacing: "0.5px",
//                       background: "#F8FAFC",
//                       borderBottom: `1px solid ${C.border}`,
//                       whiteSpace: "nowrap",
//                       py: "10px",
//                     }}
//                   >
//                     {h}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {challanLoading ? (
//                 <TableRow>
//                   <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
//                     <CircularProgress size={24} sx={{ color: C.accent }} />
//                   </TableCell>
//                 </TableRow>
//               ) : filteredChallans.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={8} align="center" sx={{ py: 4, color: C.muted, fontSize: 13 }}>
//                     No delivery challans found.
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 filteredChallans.map((row, idx) => {
//                   // Parse table_details for cylinder count and total qty
//                   let cylCount = 0;
//                   let totalQty = 0;
//                   try {
//                     const items = typeof row.table_details === "string"
//                       ? JSON.parse(row.table_details)
//                       : row.table_details || [];
//                     if (Array.isArray(items)) {
//                       cylCount = items.filter((c) => c.cyl_id).length;
//                       totalQty = items.reduce((s, c) => s + (parseFloat(c.qty) || 0), 0);
//                     }
//                   } catch {}

//                   return (
//                     <TableRow
//                       key={row.entry_id || idx}
//                       hover
//                       sx={{
//                         "&:last-child td": { border: 0 },
//                         background: toDateStr(row.entry_date) === today ? "#FAFFFE" : "inherit",
//                       }}
//                     >
//                       <TableCell sx={{ fontSize: 12, fontFamily: "monospace", color: C.accent, fontWeight: 600, whiteSpace: "nowrap" }}>
//                         {row.entry_no || "—"}
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, color: C.muted, whiteSpace: "nowrap" }}>
//                         {toDateStr(row.entry_date)}
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, color: C.navy, maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                         {row.customer_name || row.to_customer_id || "—"}
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, color: C.muted }}>
//                         {row.driver_name || "—"}
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, fontFamily: "monospace", color: C.muted }}>
//                         {row.vehicle_no || "—"}
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 13, fontWeight: 600, color: C.navy, textAlign: "center" }}>
//                         {cylCount}
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, color: C.muted }}>
//                         {totalQty > 0 ? `${totalQty.toFixed(1)} kg` : "—"}
//                       </TableCell>
//                       <TableCell>
//                         <StatusChip status={row.status || row.cancel_reason ? "cancelled" : "created"} />
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Footer */}
//         <Box sx={{ p: "10px 18px", borderTop: `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <Box sx={{ fontSize: 11, color: C.muted }}>
//             Showing {filteredChallans.length} of {challans.length} records
//           </Box>
//           <Box sx={{ fontSize: 11, color: C.muted }}>
//             Total cylinders delivered today:{" "}
//             <Box component="span" sx={{ fontWeight: 700, color: C.accent }}>
//               {deliveredToday}
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default DepotDashboard;


import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import {
  Box, Grid, Card, CardContent, Typography, CircularProgress,
  Chip, FormControl, InputLabel, Select, MenuItem,
  Table, TableBody, TableContainer, TableHead, TableRow, TableCell,
  TextField, InputAdornment,
  Dialog, DialogTitle, DialogContent, IconButton,   // 👈 add
} from "@mui/material";
import {
  Inventory2, LocalShipping, SyncAlt, CheckCircle,
  Warehouse, Refresh, Search, Close,                 // 👈 Close add
} from "@mui/icons-material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import axiosClient from "../../configs/axios";
import depotMasterService from "../../services/masters/depotMaster.Service";
import deliveryChallanService from "../../services/deliveryChallan.Service";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// ─── Design tokens — exact same as PlantDashboard ─────────────────────────────
const C = {
  navy:      "#1B3A6B",
  accent:    "#2563EB",
  bg:        "#F0F4F8",
  card:      "#FFFFFF",
  border:    "#E2E8F0",
  textMuted: "#64748B",
  success:   "#16A34A",
  warn:      "#D97706",
  err:       "#DC2626",
};

const CHART_COLORS = {
  full:      "#16A34A",
  empty:     "#DC2626",
  delivered: "#2563EB",
  transit:   "#D97706",
};

const REFRESH_INTERVAL_MS = 60_000;

// ─── Helpers ──────────────────────────────────────────────────────────────────
const getUserInfo = () => {
  try {
    const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
    return d?.result?.userInfo || {};
  } catch { return {}; }
};

const toDateKey = (val) => {
  if (!val) return "";
  return String(val).split("T")[0].split(" ")[0];
};

const todayISO = () => new Date().toISOString().split("T")[0];

const countCylindersFromDetails = (tableDetails) => {
  try {
    const arr = typeof tableDetails === "string"
      ? JSON.parse(tableDetails)
      : tableDetails;
    if (!Array.isArray(arr)) return 0;
    return arr.filter((c) => c.cyl_id).length;
  } catch { return 0; }
};

const calcQtyFromDetails = (tableDetails) => {
  try {
    const arr = typeof tableDetails === "string"
      ? JSON.parse(tableDetails)
      : tableDetails;
    if (!Array.isArray(arr)) return 0;
    return arr.reduce((s, c) => s + (parseFloat(c.qty) || 0), 0);
  } catch { return 0; }
};

// ─── KPI Card — same as PlantDashboard ───────────────────────────────────────
// ─── KPI Card — same as PlantDashboard ───────────────────────────────────────
const KpiCard = ({ label, value, unit, icon: Icon, accentColor = C.accent, loading }) => (
  <Card
    elevation={0}
    sx={{
      border: `1px solid ${accentColor}`,
      borderRadius: "10px",
      background: accentColor,
      height: "100%",
    }}
  >
    <CardContent sx={{ p: "12px 14px !important" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.85)", fontWeight: 500, letterSpacing: 0.4, textTransform: "uppercase", mb: 0.5 }}>
            {label}
          </Typography>
          {loading ? (
            <CircularProgress size={18} sx={{ color: "#fff", mt: 0.5 }} />
          ) : (
            <Typography sx={{ fontSize: 24, fontWeight: 700, color: "#fff", lineHeight: 1 }}>
              {value ?? "—"}
            </Typography>
          )}
          {unit && !loading && (
            <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.85)", mt: 0.3 }}>{unit}</Typography>
          )}
        </Box>
        <Icon sx={{ fontSize: 26, color: "#fff", opacity: 0.35, mt: 0.3 }} />
      </Box>
    </CardContent>
  </Card>
);

// ─── Status Chip ──────────────────────────────────────────────────────────────
const STATUS_MAP = {
  delivered:    { label: "Delivered",   bg: "#D1FAE5", color: "#065F46" },
  "in-transit": { label: "In Transit",  bg: "#FEF3C7", color: "#92400E" },
  cancelled:    { label: "Cancelled",   bg: "#FEE2E2", color: "#991B1B" },
  booked:       { label: "Booked",      bg: "#DBEAFE", color: "#1E40AF" },
  created:      { label: "Created",     bg: "#F1F5F9", color: "#475569" },
};

const StatusBadge = ({ status }) => {
  const key = (status || "created").toLowerCase().replace(/\s+/g, "-");
  const cfg = STATUS_MAP[key] || STATUS_MAP.created;
  return (
    <Box
      component="span"
      sx={{
        fontSize: 10,
        fontWeight: 600,
        px: "8px",
        py: "3px",
        borderRadius: "20px",
        background: cfg.bg,
        color: cfg.color,
        whiteSpace: "nowrap",
      }}
    >
      {cfg.label}
    </Box>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
const DepotDashboard = () => {
  const userInfo    = useMemo(() => getUserInfo(), []);
  const userDepotId = userInfo?.depot_id ? String(userInfo.depot_id) : "";

  // ── State ─────────────────────────────────────────────────────────────────
  const [depots,          setDepots]          = useState([]);
  const [selectedDepot,   setSelectedDepot]   = useState(userDepotId);

  // Inventory from /dashboard/inventory
  const [invData,         setInvData]         = useState(null);
  const [invLoading,      setInvLoading]      = useState(true);

  // Depot-wise count from /dashboard/depot-cylinder-count
  const [depotCount,      setDepotCount]      = useState([]);
  const [countLoading,    setCountLoading]    = useState(true);

  // Delivery challans
  const [challans,        setChallans]        = useState([]);
  const [challanLoading,  setChallanLoading]  = useState(true);
  const [searchKey,       setSearchKey]       = useState("");

  const [lastRefreshed,   setLastRefreshed]   = useState(null);
  const timerRef = useRef(null);

  const today = useMemo(() => todayISO(), []);

  // ── Fetch depot list ───────────────────────────────────────────────────────
  useEffect(() => {
    depotMasterService
      .getDepotList({ page: 0, size: 999, searchKey: "" })
      .then((data) => setDepots(data || []))
      .catch(console.error);
  }, []);

  // ── Core fetch ────────────────────────────────────────────────────────────
  const fetchAll = useCallback(async () => {
    setInvLoading(true);
    setCountLoading(true);
    setChallanLoading(true);

    const invParams = {};
    if (selectedDepot) invParams.depot_id = selectedDepot;

    try {
      const [invRes, countRes] = await Promise.allSettled([
        axiosClient.get("/dashboard/inventory", { params: invParams }),
        axiosClient.get("/dashboard/depot-cylinder-count"),
      ]);

      if (invRes.status === "fulfilled")   setInvData(invRes.value.data || {});
      if (countRes.status === "fulfilled") setDepotCount(countRes.value.data || []);
    } catch (e) {
      console.error("DepotDashboard fetchAll:", e);
    } finally {
      setInvLoading(false);
      setCountLoading(false);
    }

    // Challans
    try {
      const data = await deliveryChallanService.getDeliveryChallanList({
        page: 0,
        size: 100,
        searchKey: "",
        depot_id: selectedDepot || "",
      });
      const rows = Array.isArray(data) ? data : data?.data || [];
      setChallans(rows);
    } catch (e) {
      console.error("Challan fetch:", e);
      setChallans([]);
    } finally {
      setChallanLoading(false);
    }

    setLastRefreshed(new Date());
  }, [selectedDepot]);



  const [transitOpen, setTransitOpen]     = useState(false);
const [transitType, setTransitType]     = useState(null); // 'empty' | 'full'
const [transitRows, setTransitRows]     = useState([]);
const [transitLoading, setTransitLoading] = useState(false);

const openTransitDialog = useCallback(async (type) => {
  setTransitType(type);
  setTransitOpen(true);
  setTransitLoading(true);
  try {
    const url = type === "empty" ? "/dashboard/in-transit-empty" : "/dashboard/in-transit-full";
    const params = {};
    if (selectedDepot) params.depot_id = selectedDepot;
    const res = await axiosClient.get(url, { params });
    setTransitRows(res.data || []);
  } catch (e) {
    console.error("Transit list fetch:", e);
    setTransitRows([]);
  } finally {
    setTransitLoading(false);
  }
}, [selectedDepot]);

  useEffect(() => {
    fetchAll();
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(fetchAll, REFRESH_INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, [fetchAll]);

  // ── KPI values ────────────────────────────────────────────────────────────
  const fullCount  = invData ? (invData.full?.tgpl  || 0) + (invData.full?.customer  || 0) : null;
  const emptyCount = invData ? (invData.empty?.tgpl || 0) + (invData.empty?.customer || 0) : null;
  const inTransitEmpty = invData ? (invData.inTransit?.empty || 0) : null;
const inTransitFull  = invData ? (invData.inTransit?.full  || 0) : null;

  // Delivered today — from challan list, today's date, sum cylinder count
  const deliveredToday = useMemo(() => {
    return challans
      .filter((c) => toDateKey(c.entry_date) === today && !c.is_deleted)
      .reduce((sum, c) => sum + countCylindersFromDetails(c.table_details), 0);
  }, [challans, today]);

  // ── Chart data: depot-wise full vs empty ──────────────────────────────────
  const barData = useMemo(() => {
    const rows = selectedDepot
      ? depotCount.filter((r) => String(r.depot_id) === String(selectedDepot))
      : depotCount;
    if (!rows.length) return null;
    return {
      labels: rows.map((r) => r.depot_name || `Depot ${r.depot_id}`),
    datasets: [
  {
    label: "Full",
    data: rows.map((r) => Number(r.full_count) || 0),
    backgroundColor: CHART_COLORS.full,
    borderWidth: 0,
    borderRadius: 3,
    barThickness: 40,   // ← fixed pixel width
  },
  {
    label: "Empty",
    data: rows.map((r) => Number(r.empty_count) || 0),
    backgroundColor: CHART_COLORS.empty,
    borderWidth: 0,
    borderRadius: 3,
    barThickness: 40,   // ← fixed pixel width
  },
],
    };
  }, [depotCount, selectedDepot]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 24 } },
    plugins: {
      legend: { display: false },
      tooltip: { mode: "index", intersect: false },
      datalabels: {
        anchor: "end",
        align: "end",
        offset: 4,
        color: C.navy,
        font: { size: 10, weight: "600" },
        formatter: (value) => (value === 0 ? "" : value),
      },
    },
    scales: {
      x: {
        ticks: { autoSkip: false, maxRotation: 0, font: { size: 11 } },
        grid: { display: false },
      },
      y: {
        beginAtZero: true,
        ticks: { font: { size: 11 } },
        grid: { color: "rgba(0,0,0,0.05)" },
      },
    },
  };

  // ── Filtered challans ─────────────────────────────────────────────────────
  const filteredChallans = useMemo(() => {
    if (!searchKey) return challans;
    const q = searchKey.toLowerCase();
    return challans.filter(
      (c) =>
        c.entry_no?.toLowerCase().includes(q) ||
        c.driver_name?.toLowerCase?.().includes(q) ||
        c.vehicle_no?.toLowerCase?.().includes(q) ||
        c.customer_name?.toLowerCase?.().includes(q)
    );
  }, [challans, searchKey]);

  // ── Selected depot name ───────────────────────────────────────────────────
  const selectedDepotName = useMemo(() => {
    const d = depots.find((d) => String(d.depot_id) === String(selectedDepot));
    return d?.depot_name ?? "Depot";
  }, [depots, selectedDepot]);

  const kpis = [
  { label: "Full Cylinders",    value: invLoading ? null : fullCount,        unit: "at depot",   icon: Inventory2,    color: C.success },
  { label: "Empty Cylinders",   value: invLoading ? null : emptyCount,       unit: "at depot",   icon: Inventory2,    color: C.err     },
  // "In Transit" yahan se hata diya — neeche special card banega
  { label: "Delivered Today",   value: challanLoading ? null : deliveredToday, unit: "cylinders", icon: CheckCircle,   color: C.accent  },
];

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, background: C.bg, minHeight: "100vh" }}>

      {/* ── Header — exact same structure as PlantDashboard ── */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 2.5 }}>
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 600, color: C.navy }}>Depot Dashboard</Typography>
          <Typography sx={{ fontSize: 12, color: C.textMuted, mt: 0.3 }}>
            CYL Tracking System — {selectedDepotName}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          {/* Depot selector — only when not a depot-role user */}
          {!userDepotId && depots.length > 0 && (
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel sx={{ fontSize: 12 }}>Depot</InputLabel>
              <Select
                value={selectedDepot}
                label="Depot"
                onChange={(e) => setSelectedDepot(e.target.value)}
                sx={{ fontSize: 12, background: C.card }}
              >
                <MenuItem value=""><em>All Depots</em></MenuItem>
                {depots.map((d) => (
                  <MenuItem key={d.depot_id} value={String(d.depot_id)} sx={{ fontSize: 12 }}>
                    {d.depot_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {lastRefreshed && (
            <Typography sx={{ fontSize: 11, color: C.textMuted }}>
              Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
            </Typography>
          )}

          <Chip
            label="Depot"
            size="small"
            icon={<Warehouse sx={{ fontSize: "13px !important", color: `${C.accent} !important` }} />}
            sx={{ background: "#EFF6FF", color: C.accent, border: "0.5px solid #BFDBFE", fontSize: 11, fontWeight: 500 }}
          />

          <Box
            component="span"
            onClick={fetchAll}
            title="Refresh now"
            sx={{ cursor: "pointer", color: C.textMuted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}
          >
            <Refresh sx={{ fontSize: 18 }} />
          </Box>
        </Box>
      </Box>

      {/* ── KPI Row — same grid as PlantDashboard ── */}
      {/* <Grid container spacing={1.5} sx={{ mb: 2 }}>
        {kpis.map((k) => (
          <Grid item xs={6} sm={3} md={3} key={k.label}>
            <KpiCard
              label={k.label}
              value={k.value}
              unit={k.unit}
              icon={k.icon}
              accentColor={k.color}
              loading={k.value === null}
            />
          </Grid>
        ))}
      </Grid> */}


      {/* ── KPI Row ── */}
<Grid container spacing={1.5} sx={{ mb: 2 }}>
  {kpis.slice(0, 2).map((k) => (
    <Grid item xs={6} sm={3} md={3} key={k.label}>
      <KpiCard label={k.label} value={k.value} unit={k.unit} icon={k.icon} accentColor={k.color} loading={k.value === null} />
    </Grid>
  ))}

  {/* ── In Transit — Empty / Full split, clickable ── */}
  <Grid item xs={6} sm={3} md={3}>
    <Card elevation={0} sx={{ border: `1px solid ${C.warn}`, borderRadius: "10px", background: C.warn, height: "100%" }}>
      <CardContent sx={{ p: "12px 14px !important" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 0.5 }}>
          <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.85)", fontWeight: 500, letterSpacing: 0.4, textTransform: "uppercase" }}>
            In Transit
          </Typography>
          <SyncAlt sx={{ fontSize: 20, color: "#fff", opacity: 0.35 }} />
        </Box>
        {invLoading ? (
          <CircularProgress size={16} sx={{ color: "#fff" }} />
        ) : (
          <Box sx={{ display: "flex", gap: 10 }}>
            <Box
              onClick={() => openTransitDialog("empty")}
              sx={{ cursor: "pointer", "&:hover": { opacity: 0.8 } }}
            >
              <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#fff", lineHeight: 1 }}>
                {inTransitEmpty ?? 0}
              </Typography>
              <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.85)", textDecoration: "underline" }}>
                Empty
              </Typography>
            </Box>
            <Box
              onClick={() => openTransitDialog("full")}
              sx={{ cursor: "pointer", "&:hover": { opacity: 0.8 } }}
            >
              <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#fff", lineHeight: 1 }}>
                {inTransitFull ?? 0}
              </Typography>
              <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.85)", textDecoration: "underline" }}>
                Full
              </Typography>
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  </Grid>

  {kpis.slice(2).map((k) => (
    <Grid item xs={6} sm={3} md={3} key={k.label}>
      <KpiCard label={k.label} value={k.value} unit={k.unit} icon={k.icon} accentColor={k.color} loading={k.value === null} />
    </Grid>
  ))}
</Grid>

      {/* ── Bar Chart — same Card/CardContent as PlantDashboard ── */}
     

      {/* ── Delivery Challan Table — same Card/CardContent ── */}
      <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "10px", background: C.card }}>
        <CardContent sx={{ p: "14px 16px !important" }}>

          {/* Table header row */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <LocalShipping sx={{ fontSize: 16, color: C.accent }} />
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: C.navy }}>
                Delivery challans
              </Typography>
              <Chip
                label={`${filteredChallans.length} records`}
                size="small"
                sx={{ fontSize: 10, background: "#EFF6FF", color: C.accent, ml: 0.5 }}
              />
            </Box>
            <TextField
              size="small"
              placeholder="Search challan no., driver, vehicle…"
              value={searchKey}
              onChange={(e) => setSearchKey(e.target.value)}
              sx={{
                width: 260,
                "& .MuiOutlinedInput-root": {
                  fontSize: 12,
                  borderRadius: "8px",
                  background: C.card,
                  "& fieldset": { borderColor: C.border },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ fontSize: 15, color: C.textMuted }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <TableContainer sx={{ maxHeight: 420 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {[
                    "Challan No.",
                    "Date",
                    "Customer",
                    "Driver",
                    "Vehicle",
                    "Cylinders",
                    "Qty (kg)",
                    "Status",
                  ].map((h) => (
                    <TableCell
                      key={h}
                      sx={{
                        fontSize: 10,
                        fontWeight: 600,
                        color: C.textMuted,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        background: "#F8FAFC",
                        borderBottom: `1px solid ${C.border}`,
                        whiteSpace: "nowrap",
                        py: "9px",
                      }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {challanLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                      <CircularProgress size={22} sx={{ color: C.accent }} />
                    </TableCell>
                  </TableRow>
                ) : filteredChallans.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 4, color: C.textMuted, fontSize: 13 }}>
                      No delivery challans found.
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredChallans.map((row, idx) => {
                    const cylCount = countCylindersFromDetails(row.table_details);
                    const totalQty = calcQtyFromDetails(row.table_details);
                    const isToday  = toDateKey(row.entry_date) === today;
                    const status   = row.cancel_reason ? "cancelled" : (row.status || "created");

                    return (
                      <TableRow
                        key={row.entry_id || idx}
                        hover
                        sx={{
                          "&:last-child td": { border: 0 },
                          background: isToday ? "#F0FDF4" : "inherit",
                        }}
                      >
                        <TableCell sx={{ fontSize: 12, fontFamily: "monospace", color: C.accent, fontWeight: 600, whiteSpace: "nowrap" }}>
                          {row.entry_no || "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: 11, color: C.textMuted, whiteSpace: "nowrap" }}>
                          {toDateKey(row.entry_date) || "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, color: C.navy, maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {row.customer_name || row.to_customer_id || "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, color: C.textMuted }}>
                          {row.driver_name || "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: 11, fontFamily: "monospace", color: C.textMuted }}>
                          {row.vehicle_no || "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13, fontWeight: 700, color: C.navy, textAlign: "center" }}>
                          {cylCount}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, color: C.textMuted }}>
                          {totalQty > 0 ? `${totalQty.toFixed(1)}` : "—"}
                        </TableCell>
                        <TableCell>
                          <StatusBadge status={status} />
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Footer */}
          <Box sx={{ pt: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: `1px solid ${C.border}`, mt: 1 }}>
            <Typography sx={{ fontSize: 11, color: C.textMuted }}>
              Showing {filteredChallans.length} of {challans.length} records
            </Typography>
            <Typography sx={{ fontSize: 11, color: C.textMuted }}>
              Delivered today:{" "}
              <Box component="span" sx={{ fontWeight: 700, color: C.accent }}>
                {deliveredToday} cylinders
              </Box>
            </Typography>
          </Box>
        </CardContent>
      </Card>

      {/* ── In Transit Drilldown Dialog ── */}
<Dialog open={transitOpen} onClose={() => setTransitOpen(false)} maxWidth="sm" fullWidth
  PaperProps={{ sx: { borderRadius: "12px" } }}>
  <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: C.navy, color: "#fff", fontSize: 14, fontWeight: 700, py: 1.5 }}>
    {transitType === "empty" ? "Empty Cylinders — In Transit (ECR)" : "Full Cylinders — In Transit (DC)"}
    <IconButton size="small" onClick={() => setTransitOpen(false)} sx={{ color: "#fff" }}>
      <Close sx={{ fontSize: 18 }} />
    </IconButton>
  </DialogTitle>
  <DialogContent sx={{ p: 0 }}>
    <TableContainer sx={{ maxHeight: 420 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontSize: 11, fontWeight: 700, background: "#F8FAFC" }}>
              {transitType === "empty" ? "ECR No." : "DC No."}
            </TableCell>
            <TableCell sx={{ fontSize: 11, fontWeight: 700, background: "#F8FAFC" }}>Date</TableCell>
            {transitType === "empty" && (
              <TableCell sx={{ fontSize: 11, fontWeight: 700, background: "#F8FAFC" }}>Customer</TableCell>
            )}
            <TableCell sx={{ fontSize: 11, fontWeight: 700, background: "#F8FAFC" }} align="center">
              No. of Cylinders
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transitLoading ? (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                <CircularProgress size={20} />
              </TableCell>
            </TableRow>
          ) : transitRows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 3, color: C.textMuted, fontSize: 12 }}>
                No records found.
              </TableCell>
            </TableRow>
          ) : (
            transitRows.map((row, idx) => (
              <TableRow key={row.entry_no || idx} hover>
                <TableCell sx={{ fontSize: 12, fontFamily: "monospace", color: C.accent, fontWeight: 600 }}>
                  {row.entry_no}
                </TableCell>
                <TableCell sx={{ fontSize: 12, color: C.textMuted }}>
                  {toDateKey(row.entry_date)}
                </TableCell>
                {transitType === "empty" && (
                  <TableCell sx={{ fontSize: 12 }}>{row.customer_name}</TableCell>
                )}
                <TableCell align="center" sx={{ fontSize: 13, fontWeight: 700, color: C.navy }}>
                  {row.no_of_cylinders}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </DialogContent>
</Dialog>
    </Box>
  );
};

export default DepotDashboard;